// extracted by mini-css-extract-plugin
module.exports = {"container":"TAListView_container__TeLRf","createElementContainer":"TAListView_createElementContainer__33n7f","emptyDataContainer":"TAListView_emptyDataContainer__1tJuT"};